"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runSideEffect = exports.toggleState = exports.resetAllToInitialState = exports.resetToInitialState = exports.updateState = exports.reducerActionKeys = void 0;
var NS = 'TREBLE_CORE_';
var reducerActionKeys = {
  update: "".concat(NS, "update"),
  toggle: "".concat(NS, "toggle"),
  run: "".concat(NS, "run"),
  reset: "".concat(NS, "reset"),
  resetAll: "".concat(NS, "resetAll")
};
exports.reducerActionKeys = reducerActionKeys;

var updateState = function updateState(data) {
  return data.dispatchValue;
};

exports.updateState = updateState;

var resetToInitialState = function resetToInitialState(data) {
  return data.initialState;
};

exports.resetToInitialState = resetToInitialState;

var resetAllToInitialState = function resetAllToInitialState(data) {
  data.storeItems.map(function (item) {
    var _data$dispatchers;

    (_data$dispatchers = data.dispatchers) === null || _data$dispatchers === void 0 ? void 0 : _data$dispatchers.reset(item.action);
  });
};

exports.resetAllToInitialState = resetAllToInitialState;

var toggleState = function toggleState(data) {
  var currentState = data.currentState;
  return currentState ? false : true;
};

exports.toggleState = toggleState;

var runSideEffect = function runSideEffect() {
  return null;
};

exports.runSideEffect = runSideEffect;